import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_ontos_formula_input = _resolveComponent("ontos-formula-input")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.value === undefined)
      ? (_openBlock(), _createBlock(_component_v_btn, {
          key: 0,
          variant: "text",
          "prepend-icon": "mdi-filter-outline",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('input', '')))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$tt('option-filter')), 1)
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock(_component_v_row, {
          key: 1,
          dense: "",
          align: "start"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              cols: "12",
              md: "7"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ontos_formula_input, _mergeProps({
                  ref: "editor",
                  class: "required"
                }, _ctx.bindings, {
                  label: _ctx.$tt('option-filter'),
                  value: _ctx.value,
                  "option-filter": "",
                  draft: _ctx.draft,
                  "result-label": _ctx.resultLabel,
                  example: _ctx.example,
                  onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('input', $event)))
                }), null, 16, ["label", "value", "draft", "result-label", "example"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "10",
              md: "4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_text_field, {
                  label: _ctx.$tt('rule-message'),
                  hint: _ctx.$tt('option-filter-message-hint'),
                  "persistent-hint": "",
                  "model-value": _ctx.message,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('message', $event || undefined)))
                }, null, 8, ["label", "hint", "model-value"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "2",
              md: "1"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  icon: "",
                  variant: "text",
                  size: "small",
                  title: _ctx.$tt('remove'),
                  onClick: _ctx.remove
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                        _createTextVNode("mdi-delete-outline", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["title", "onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
  ]))
}